
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes, Link, Navigate, useNavigate } from 'react-router-dom';
import ContactMessagesPage from './ContactMessagesPage';
import AddStore from './AddStore';
import StoresList from './StoresList';
import StoreDetails from './StoreDetails';
import { Header } from '../components/header';
import { useAdminAuth } from '../context/AdminAuthContext';

export default function AdminDashboard() {
  const { t } = useTranslation();
  const { logout, isAdmin } = useAdminAuth();
  const navigate = useNavigate();

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <>
      <Header />
      <div className="min-h-screen flex">
        <aside className="w-64 bg-slate-800 text-white flex flex-col">
          <div className="p-6 text-2xl font-bold border-b border-slate-700">{t('admin:portalTitle', 'Admin Portal')}</div>
          <nav className="flex-1 p-4">
            <ul className="space-y-2">
              <li>
                <Link to="/admin/contact-messages" className="block py-2 px-4 rounded hover:bg-slate-700">{t('admin:contactMessages', 'Contact Messages')}</Link>
              </li>
              <li>
                <Link to="/admin/add-store" className="block py-2 px-4 rounded hover:bg-slate-700">{t('admin:addStore', 'Add Store')}</Link>
              </li>
              <li>
                <Link to="/admin/stores" className="block py-2 px-4 rounded hover:bg-slate-700">{t('admin:allStores', 'All Stores')}</Link>
              </li>
            </ul>
          </nav>
          <button
            onClick={handleLogout}
            className="m-4 py-2 px-4 rounded bg-red-600 hover:bg-red-700 text-white font-semibold"
          >
            {t('admin:logout', 'Logout')}
          </button>
        </aside>
        <main className="flex-1 bg-slate-50 p-8">
          <Routes>
            <Route path="contact-messages" element={<ContactMessagesPage />} />
            <Route path="add-store" element={<AddStore />} />
            <Route path="stores" element={<StoresList />} />
            <Route path="stores/:id" element={<StoreDetails />} />
            <Route path="*" element={<Navigate to="contact-messages" replace />} />
          </Routes>
        </main>
      </div>
    </>
  );
}
